import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import AppErrorBoundary, {
  clearChunkReloadGuard,
  recoverFromChunkError,
  reloadForUpdatedApplication,
} from './components/system/AppErrorBoundary.tsx'

window.setTimeout(clearChunkReloadGuard, 5_000)
window.addEventListener('unhandledrejection', (event) => {
  if (recoverFromChunkError(event.reason)) event.preventDefault()
})
window.addEventListener('vite:preloadError', (event) => {
  if (reloadForUpdatedApplication()) event.preventDefault()
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
)
